module.exports = __webpack_public_path__ + "static/media/noun_Video Conference.5ed668c7.png";